var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-block small-padding"},[_c('transition',{attrs:{"name":"slide-fade-delay"}},[(_vm.active)?_c('div',{staticClass:"content-split"},[_c('div',{staticClass:"line"}),_c('h2',{staticClass:"subtitle"},[_vm._v("\n        "+_vm._s(_vm.$t("general.label.overview"))+"\n      ")])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }